import React from 'react';

type AdressFormProps = { children: React.ReactNode };

const AdressForm = ({ children }: AdressFormProps) => {
	return (
		<div
			className="vtex-address-form__postalCode vtex-address-form__field--small
    pb7"
		>
			{children}
		</div>
	);
};

export default AdressForm;
